module.exports = __webpack_public_path__ + "static/8-apdovanojimai-efb6360df46e005cc5c4373a2a95f762.svg";